import {toast} from "react-toastify";

export const POSITION_TOAST = {
  position: toast.POSITION.BOTTOM_RIGHT,
  autoClose: 2000
}